module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h1"
    }
  }, [_vm._v("Who Should Read This Book")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h2"
    }
  }, [_vm._v("Who Are Bob and Susan Negen and Why Should You Listen to Them?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h3"
    }
  }, [_vm._v("The Bad News")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h4"
    }
  }, [_vm._v("The Good News")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h5"
    }
  }, [_vm._v("The New Millennium Merchant")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h6"
    }
  }, [_vm._v("The WhizBang! Marketing System : Four Steps to Higher Sales and Happier Customers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_itr_r1#h7"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c01_r1"
    }
  }, [_vm._v("STEP 1 - How to Get New Customers without Going Broke")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c01_r1#h1"
    }
  }, [_vm._v("Five Key Concepts for Getting New Customers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c01_r1#h2"
    }
  }, [_vm._v("Six Low-Tech Tactics to Get New Customers without Going Broke")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c01_r1#h3"
    }
  }, [_vm._v("Six High-Tech Tactics to Get New Customers")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPECIAL SECTION - The Traditional Media")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Your Business versus Selling a Product")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Picking the Right Advertising Media")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c02_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Types of Advertising Tools")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPECIAL SECTION - Copywriting for Retailers")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killer Copy: How to Write Messages That Sell")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Concepts to Consider")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEP 2 - Turn a First-Time Buyer into a Regular Customer")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Key Concepts for Turning a First-Time Buyer into a Regular Customer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Low-Tech Tactics for Turning a First-Time Buyer into a Regular Customer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two High-Tech Tactics for Turning a First-Time Buyer into a Regular Customer")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEP 3 - Get Your Customers to Shop More Often")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Key Concepts to Get Your Customers to Shop More Often")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Low-Tech Tactics to Get Your Customers to Shop More Often")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four High-Tech Tactics to Get Your Customers to Shop More Often")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEP 4 - Keep Your Customers for Life")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six Key Concepts to Keep Customers for Life")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Terrific Tactics to Keep Customers for Life")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/nege_9781118044704_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba1e2c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nege_9781118044704_oeb_toc_r1.vue
// module id = 57
// module chunks = 0